import React from 'react';

const Product = ({ inventory, add, remove, cart, isLoading, setDetail }) => {
	return (
		<section className='store wrapper' id='products'>
			{isLoading ? <h2>Loading products...</h2> : <h2>New Arrivals</h2>}

			<ul className='products'>
				{inventory.map(item => {
					if (item.stock > 0) {
						return (
							<li className='productInfo' key={item.id}>
								{item.onSale ? (
									<figure className='itemImage onSale'>
										<figcaption>
											<button
												onClick={() => {
													setDetail(item.id);
												}}
												className='viewDetail'>
												View detail
											</button>
										</figcaption>
										<img
											src={item.url}
											alt={`Close up shot of a person wearing ${item.name}`}
										/>
									</figure>
								) : (
									<figure className='itemImage'>
										<figcaption>
											<button
												onClick={() => {
													setDetail(item.id);
												}}
												className='viewDetail'>
												View detail
											</button>
										</figcaption>
										<img
											src={item.url}
											alt={`Close up shot of a person wearing ${item.name}`}
										/>
									</figure>
								)}

								<h3>{item.name}</h3>
								<p className='price'>${item.price}</p>
								<p>
									<span className='stock'>{item.stock}</span> left in stock
								</p>
								<div className='setQuant'>
									{cart[item.id] > 0 ? (
										<button
											className='remove'
											onClick={() => {
												remove(item.id);
											}}>
											-
										</button>
									) : (
										<button className='remove' disabled={true}>
											-
										</button>
									)}
									<span className='quantity'>{cart[item.id]}</span>
									{cart[item.id] < item.stock ? (
										<button
											className='add'
											onClick={() => {
												add(item.id);
											}}>
											+
										</button>
									) : (
										<button className='add' disabled='true'>
											+
										</button>
									)}
								</div>
							</li>
						);
					} else {
						return (
							<li className='productInfo soldOutItem'>
								<figure className='itemImage'>
									<figcaption>
										<button className='viewDetail'>View detail</button>
									</figcaption>
									<img
										src={item.url}
										alt={`Close up shot of a person wearing ${item.name}`}
									/>
								</figure>
								<h3>{item.name}</h3>
								<p>${item.price}</p>
								<p className='soldOut'>sold out</p>
							</li>
						);
					}
				})}
			</ul>
		</section>
	);
};

export default Product;
